module.exports = __webpack_public_path__ + "static/scale-model-of-waveland-state-historic-site-in-lexington-kentucky-db302724ae955e6810f5694b3d181ac2.png";